module.exports = __webpack_public_path__ + "static/logo-069a46528b7ef2e7e83d1390627c4944.png";